import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import {
  financialCalculators,
  fitnessCalculators,
  mathCalculators,
  otherCalculators
} from '../data/mock';

const CategoryPage = () => {
  const { category } = useParams();

  const getCategoryData = () => {
    switch (category) {
      case 'financial-calculators':
        return { title: 'Financial Calculators', calculators: financialCalculators };
      case 'fitness-calculators':
        return { title: 'Fitness & Health Calculators', calculators: fitnessCalculators };
      case 'math-calculators':
        return { title: 'Math Calculators', calculators: mathCalculators };
      case 'other-calculators':
        return { title: 'Other Calculators', calculators: otherCalculators };
      default:
        return { title: 'Calculators', calculators: [] };
    }
  };

  const { title, calculators } = getCategoryData();

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />

      <main className="flex-1">
        <div className="max-w-5xl mx-auto px-4 py-8">
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">{title}</span>
          </nav>

          <h1 className="text-3xl font-bold text-white mb-8">{title}</h1>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {calculators.map((calc, index) => (
              <Link
                key={index}
                to={calc.path}
                className="block p-5 bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl hover:border-cyan-500/50 hover:bg-[#1f1f1f] transition-all group"
              >
                <span className="text-white font-medium group-hover:text-cyan-400 transition-colors">{calc.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CategoryPage;
